module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.2ff7d650.woff2";